import React, { FC } from 'react';

import styles from '../ActionModal.module.scss';

import InfoTextBlock from 'src/atoms/InfoTextBlock';
import ControlBtns from './ControlBtns';

type TDeleteActionProps = {
  text: string;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteAction: FC<TDeleteActionProps> = ({ onClose, onConfirm, text }) => {
  return (
    <>
      <InfoTextBlock classes={{ wrapper: styles.deleteDescriptionWrapper }}>{text}</InfoTextBlock>

      <ControlBtns isDelete onClose={onClose} onConfirm={onConfirm} />
    </>
  );
};

export default DeleteAction;
